import { useCachedQuery } from '@kaiizen/react-persistent-cache';
import { useKaiProApiClient } from '../useKaiProApiClient';

/**
 * Super admin only: the server's health details from /api/heartbeat, refetched every time a view mounts.
 * `details` stays undefined for anyone else.
 */
export const useHeartbeatDetails = () => {
  const kaiProApiClient = useKaiProApiClient();

  const query = useCachedQuery(
    'heartbeatDetails',
    () => kaiProApiClient.heartbeat(),
    { enabled: !!kaiProApiClient.token, staleAgeMs: 0 },
  );

  return { details: query.data?.details, isFetching: query.isFetching, errorInfo: query.errorInfo, refetch: query.refetch };
};
